import { useQuery } from "@tanstack/react-query";
import { userApi } from "@/lib/api";
import { useSession } from "@/lib/store/session";
import { keys } from "./keys";

export function useUser() {
  const userId = useSession((s) => s.userId);
  return useQuery({
    queryKey: keys.user(userId),
    queryFn: userApi.summary,
    enabled: !!userId,
    staleTime: 5 * 60_000,
  });
}

/** Metres to round up by, or 0. The server stores a boolean-ish value; the Quasar app treated it as metres. */
export function roundUpMetres(v: number | boolean | null | undefined): number {
  if (typeof v === "number") return v > 0 ? v : 0;
  return 0;
}
